import React from 'react';
import { Button } from './Button';
import { Icon } from './Icon';
import { useLanguage } from '../contexts/LanguageContext';
import { FANVUE_PROFILE_URL } from '../utils/fanvue';
export function Gallery() {
  const {
    t
  } = useLanguage();
  const images = [{
    src: 'https://cdn.magicpatterns.com/uploads/rfvrNZA6QFevmPKKdBzmH8/IMG_5995.JPG.jpg',
    alt: 'Alexaaa Narvaez - Alta Moda',
    categoryKey: 'gallery.category1'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/pUXVahmqVccsp1oLQ6FBMM/IMG_6519.JPG.jpg',
    alt: 'Alexaaa Narvaez - Editorial',
    categoryKey: 'gallery.category2'
  }];
  return <section id="galeria" className="py-20 md:py-32 px-6 bg-[#0a0a0a]" data-id="element-111" data-mp="2zeof9ova7e1s">
      <div className="max-w-5xl mx-auto" data-id="element-112" data-mp="2ulltw40nrawo">
        {/* Header - Centered */}
        <div className="text-center mb-16 md:mb-20" data-id="element-113" data-mp="26wj3a6o1q7q1">
          <span className="inline-block text-[#C5A028] text-xs font-medium tracking-[0.2em] uppercase mb-4" data-id="element-114" data-mp="26v7yq4ms0vxv">
            {t('gallery.label')}
          </span>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-white mb-5 tracking-tight leading-tight" data-id="element-115" data-mp="rdcjgfe7bjzg">
            {t('gallery.title')}
          </h2>
          <p className="text-white/50 font-light max-w-xl mx-auto leading-relaxed text-sm md:text-base" data-id="element-116" data-mp="112cly8rwwxie">
            {t('gallery.subtitle')}
          </p>
          <div className="w-20 h-px bg-gradient-to-r from-transparent via-[#C5A028]/40 to-transparent mx-auto mt-6" data-id="element-117" data-mp="153g2yylp4zl7" />
        </div>

        {/* Gallery Grid - Editorial Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 mb-16 md:mb-20" data-id="element-118" data-mp="ddtetwklmqrw">
          {images.map((image, index) => <div key={index} className="group relative aspect-[3/4] overflow-hidden rounded-sm animate-slide-up" style={{
          animationDelay: `${index * 0.15}s`
        }} data-id="element-119" data-mp="hd28z2jjwqnz" data-mpi={index}>
              {/* Image with Balanced Editorial Treatment */}
              <img src={image.src} alt={image.alt} className="w-full h-full object-cover transition-all duration-700 group-hover:scale-105" style={{
            filter: 'brightness(1.05) contrast(1.05) saturate(1.0)'
          }} data-id="element-120" data-mp="1xupzb3sjomlq" />

              {/* Lighter Permanent Overlay - Much more subtle */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-black/10" data-id="element-121" data-mp="2q9x2dmk9m56" />

              {/* Enhanced Overlay on Hover */}
              <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-all duration-500" data-id="element-122" data-mp="366ytv7wcdhhn" />

              {/* Editorial Frame */}
              <div className="absolute inset-0 border border-white/10" data-id="element-123" data-mp="3g4d6ewf59m4o" />

              {/* Category Badge - Always Visible */}
              <div className="absolute top-6 left-6 transition-all duration-500" data-id="element-124" data-mp="2se0qozdnql3j">
                <span className="bg-black/50 backdrop-blur-sm border border-[#C5A028]/30 text-[#C5A028] text-xs font-medium tracking-wider px-4 py-2 rounded-sm" data-id="element-125" data-mp="2nfz62a0l2dpy">
                  {t(image.categoryKey)}
                </span>
              </div>

              {/* Hover Icon */}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500" data-id="element-126" data-mp="17q84rqkt64yv">
                <div className="w-16 h-16 rounded-full bg-black/40 backdrop-blur-md flex items-center justify-center border border-white/20 transform scale-75 group-hover:scale-100 transition-transform duration-500" data-id="element-127" data-mp="xzlt27g7pylg">
                  <Icon name="arrow-right" size={20} className="text-white" data-id="element-128" data-mp="1qmpqnrcz7an7" />
                </div>
              </div>
            </div>)}
        </div>

        {/* CTA - Centered, Full Width on Mobile */}
        <div className="text-center" data-id="element-129" data-mp="1hkqaf19scalb">
          <div className="flex justify-center" data-id="element-130" data-mp="18kvt5q4if2o">
            <Button href={FANVUE_PROFILE_URL} variant="primary" className="w-full md:w-auto" data-id="element-131" data-mp="16qd7y2bqz1r">
              <span className="mr-2" data-id="element-132" data-mp="lgrjv9hff3oy">{t('gallery.cta')}</span>
              <Icon name="arrow-right" size={16} data-id="element-133" data-mp="licfz3je2uox" />
            </Button>
          </div>
          <p className="text-white/40 text-xs md:text-sm mt-5 font-light" data-id="element-134" data-mp="gorprxo1f50a">
            {t('gallery.ctaSubtext')}
          </p>
        </div>
      </div>
    </section>;
}